import type { Coverage } from '@ametica/shared';

export type CoverageTone = 'ok' | 'warn' | 'none';

export interface CoverageSummary {
  tone: CoverageTone;
  /** „N z M komponentov nemá žiadny záznam v katalógu" */
  headline: string;
  /** samostatná veta o komponentoch bez kľúčovateľnej verzie, alebo null */
  unkeyable: string | null;
}

export function pluralComponents(n: number): string {
  return n === 1 ? 'komponent' : n >= 2 && n <= 4 ? 'komponenty' : 'komponentov';
}

/**
 * Texty panelu pokrytia. Zámerne hovorí „nemá žiadny záznam v katalógu", nie
 * „bez nálezu": komponent, o ktorom Wordfence nič nevie, nie je bezpečný —
 * je neposúdený (slug mismatch je najtichšie zlyhanie, spec „Further Notes").
 */
export function coverageSummary(c: Pick<Coverage, 'total' | 'unknown' | 'unkeyable'>): CoverageSummary {
  if (c.total === 0) return { tone: 'none', headline: 'Zatiaľ žiadny inventár — pokrytie sa nedá posúdiť', unkeyable: null };
  const headline = c.unknown === 0
    ? `Všetkých ${c.total} ${pluralComponents(c.total)} má záznam v katalógu`
    : `${c.unknown} z ${c.total} ${pluralComponents(c.total)} nemá žiadny záznam v katalógu`;
  const unkeyable = c.unkeyable === 0 ? null
    : `${c.unkeyable} ${pluralComponents(c.unkeyable)} ${c.unkeyable === 1 ? 'nemá' : c.unkeyable <= 4 ? 'nemajú' : 'nemá'} kľúčovateľnú verziu — matching ${c.unkeyable === 1 ? 'ho' : 'ich'} nevie posúdiť`;
  return { tone: c.unknown > 0 || c.unkeyable > 0 ? 'warn' : 'ok', headline, unkeyable };
}
